import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { bedStatusAPI, systemAPI } from '../../apis';
import { setSsoStatus, updateLoginInfoAction } from '../../redux/actions';
import { addLoginAction } from '../../utils/check';
import { useQuery } from '../../utils/useQuery';
import rou from '../../router';
import Dialog from '../../components/Dialog';
import { LOGIN_INFO } from '../../comm/constant';
import { mutationUpdateOtherLoginInfo } from '../../utils/handleUpdateOtherLoginInfo';
import { updateHospitalWardListAction } from '../../redux/actions/hospitalWardList';
import { updateUserRoleAction } from '../../redux/actions/userRole';
import { CUBICLE_VIEW, CUBICLE_VIEW2 } from '../../redux/constant';

const SSO = () => {
  const query = useQuery();
  const dispatch = useDispatch();
  const history = useHistory();
  const [errorPopup, setErrorPopup] = useState(false);

  useEffect(() => {
    sessionStorage.setItem('SSO_LOGIN', true);
    sessionStorage.setItem('SSO_WARD_LOCATION', query.ward_loc);
  }, []);

  const getViewSettingAPI = async ({ wardId }) => {
    try {
      const { result } = await bedStatusAPI.getViewSettingDetail({ wardId });
      if ([CUBICLE_VIEW, CUBICLE_VIEW2].includes(result.viewType)) {
        history.push(rou.bedstatusNewRou.path);
      } else {
        history.push(rou.bedstatusRou.path);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSysUserRole = async (corpId) => {
    try {
      const { result } = await systemAPI.getSysUserRole({ corpId });
      if (Array.isArray(result)) {
        dispatch(updateHospitalWardListAction(null));
        dispatch(updateUserRoleAction(result));
      }
    } catch (error) {}
  };

  const ssoLogin = useCallback(async ({ hospital, token, userId, wardLocation }) => {
    try {
      const { result } = await systemAPI.ssoLogin({ hospital, token, userId, wardLocation });
      const temp = {
        corpID: userId,
        token: `${result.token}`,
        refreshToken: `${result.refreshToken}`,
        displayName: result.displayName,
        createTime: result.createTime,
        refreshTokenExp: result.refreshTokenExp,
      };

      const role = {
        hospitalId: result.wards[0]?.hospId ?? null,
        hospitalName: result.wards[0]?.hospitalName ?? null,
        userId: result.wards[0]?.userId ?? null,
        wardId: result.wards[0]?.wardId ?? null,
        wardName: result.wards[0]?.wardName ?? null,
      };

      dispatch(
        updateLoginInfoAction({
          ...temp,
          ...role,
          flag: true,
        })
      );
      localStorage.setItem(
        LOGIN_INFO,
        JSON.stringify({
          ...temp,
          ...role,
          flag: true,
        })
      );
      addLoginAction();

      dispatch(setSsoStatus(true));
      await getSysUserRole(userId);
      getViewSettingAPI({ wardId: role.wardId });
      sessionStorage.setItem('SSO_MEMO', query.memo === 'y');
      mutationUpdateOtherLoginInfo();
    } catch (error) {
      setErrorPopup(true);
      console.log(error);
    }
  }, []);

  useEffect(() => {
    ssoLogin({
      hospital: query.hosp,
      token: query.Token,
      userId: query.user_id,
      wardLocation: query.ward_loc,
    });
  }, [query, ssoLogin]);

  return (
    <div>
      {errorPopup && (
        <Dialog open={true} haveClose={false} title="Error" confirm="Confirm" handleConfirm={() => window.close()}>
          {`The Ward Place session is expired. Kindly close this popup/window, refresh the original system's window and
          click the Ward Place button/linkage again.`}
        </Dialog>
      )}
    </div>
  );
};

export default SSO;
